module.exports = __webpack_public_path__ + "static/media/etat-medicament-blue.316da794.svg";